// extracted by mini-css-extract-plugin
export default {"input_container":"FileLabel_input_container__acYxD"};